import React, { useEffect, useState } from "react";
import { ReactComponent as LapturaMark } from "../../assets/brand/laptura-mark.svg";
import { useAuth } from "../../contexts/AuthContext";
import api from "../../api/axiosInstance";
import toast from "react-hot-toast";
import { LegalAgreementStep } from "./LegalAgreementStep";

/** Blocks the app until the signed-in user has accepted the current terms version. */
export function LegalGate({ children }) {
  const { user, acceptLegal } = useAuth();
  const [currentVersion, setCurrentVersion] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/auth/legal")
      .then((res) => {
        if (!cancelled) setCurrentVersion(res.data.version);
      })
      .catch(() => {
        if (!cancelled) setCurrentVersion(user?.legal_version ?? null);
      });
    return () => {
      cancelled = true;
    };
  }, [user?.legal_version]);

  if (!user || currentVersion == null || user.legal_version === currentVersion) {
    return children;
  }

  const onSigned = async (accepted) => {
    setSubmitting(true);
    try {
      await acceptLegal(accepted);
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error((typeof detail === "string" && detail) || "Could not save your agreement.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="h-screen overflow-y-auto bg-lap-bg">
      <div className="mx-auto max-w-md w-full px-4 pt-[max(1.5rem,env(safe-area-inset-top,0px))] pb-[max(1.5rem,env(safe-area-inset-bottom,0px))] sm:pt-12 sm:pb-12">
        <div className="flex justify-center">
          <LapturaMark className="h-12 sm:h-16 w-auto text-lap-text" role="img" aria-label="Laptura" />
        </div>
        <h1 className="mt-6 text-center text-2xl sm:text-3xl font-extrabold text-white">Updated terms and waiver</h1>
        <p className="mt-2 mb-8 text-center text-sm text-lap-muted">
          The terms and waiver have changed since you last signed in. Please read and sign to continue.
        </p>
        <LegalAgreementStep
          onSigned={onSigned}
          submitting={submitting}
          submitLabel="Agree and continue"
        />
      </div>
    </div>
  );
}
